import { Heartbeat } from './tracking/shared/heartbeat';

const initHeartbeat = () => {
	new Heartbeat();
};

if (/complete|interactive|loaded/.test(document.readyState)) {
	initHeartbeat();
} else {
	document.addEventListener('DOMContentLoaded', () => initHeartbeat());
}
